// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.
export const MOBILE = 'MOBILE';
export const DESKTOP = 'DESKTOP';

export const REACT_SLICK_SPEED = 300; // in milliseconds

// Label for the 360 spin control. Hardcoded to match ws-vehicle-media rather
// than sourced from the label service.
export const SPIN_360_LABEL = '360\u00b0';
